import { useEffect, useMemo, useCallback } from "react";
import { useUiStore } from "@core/stores/uiStore";
import type { dialogDataType } from "@core/types/uiType";
import { shallow } from "zustand/shallow";

export const useDialog = (dialogData: dialogDataType) => {
  const { openDialogList, openDialog, closeDialog } = useUiStore(
    (state) => ({
      openDialogList: state.openDialogList,
      openDialog: state.openDialog,
      closeDialog: state.closeDialog,
    }),
    shallow,
  );

  const isOpen = useMemo(() => {
    return openDialogList.has(JSON.stringify(dialogData));
  }, [openDialogList, dialogData]);

  const open = useCallback(() => {
    return openDialog(dialogData);
  }, [dialogData, openDialog]);

  const close = useCallback(() => {
    return closeDialog(dialogData);
  }, [dialogData, closeDialog]);

  const toggle = useCallback(() => {
    if (isOpen) closeDialog(dialogData);
    else openDialog(dialogData);
  }, [isOpen, dialogData, openDialog, closeDialog]);

  return { isOpen, open, close, toggle };
};
